
import './Page4.css';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Page4() {
  const match_id = localStorage.getItem('match_id');
  const [bowlerList, setBowlerList] = useState([]);
  const [selectedBowler, setSelectedBowler] = useState('');
  const [customBowler, setCustomBowler] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (!match_id) return;
    fetch(`https://nammateam.onrender.com/bowling/${match_id}`)
      .then(res => res.json())
      .then(data => setBowlerList(data))
      .catch(err => console.error("Failed to load bowling list", err));
  }, [match_id]);

  const handleSubmit = async () => {
    const bowlerToUse = customBowler.trim() || selectedBowler;
    if (!bowlerToUse) return alert("Please select or enter a bowler name");

    const api = customBowler.trim()
      ? `https://nammateam.onrender.com/bowling/add/${match_id}`
      : `https://nammateam.onrender.com/bowling/setactive/${match_id}`;

    try {
      const res = await fetch(api, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ bowler_name: bowlerToUse })
      });
      const result = await res.json();

      if (result.success) {
        alert(`Bowler "${bowlerToUse}" set as active.`);
        navigate('/live'); // back to Page3
      } else {
        alert(result.message || "Error occurred");
      }
    } catch (error) {
      console.error("Set active bowler failed", error);
    }
  };

  return (
    <div className="page4-container">
      <h2>Select or Add Bowler</h2>

      <div className="dropdown-section">
        <label>Select from existing bowlers:</label>
        <select
          onChange={e => {
            setSelectedBowler(e.target.value);
            setCustomBowler('');
          }}
          value={selectedBowler}
        >
          <option value="">-- Choose --</option>
          {bowlerList.map((b, i) => (
            <option key={i} value={b.name}>{b.name}</option>
          ))}
        </select>
      </div>

      <div className="input-section">
        <label>Or type new bowler name:</label>
        <input
          type="text"
          placeholder="Enter new bowler"
          value={customBowler}
          onChange={e => {
            setCustomBowler(e.target.value);
            setSelectedBowler('');
          }}
        />
      </div>

      <button className="btn-gren" onClick={handleSubmit}>
        Set as Active Bowler
      </button>
    </div>
  );
}

export default Page4;
